module.exports = ":host .body {\n  margin-top: 46px; }\n"